export default "__VITE_ASSET__BhNgjJ0U__"